import { useNavigate } from 'react-router-dom'
import { LinkOption } from '../../components/LinkOptions'
//import { NewPix } from "./components/NewPix";
import bill from '../../assets/bill.svg'
import copypaste from '../../assets/copyAndPastePix.svg'
import newPixIcon from '../../assets/newPixIcon.svg'
import qrcodeicon from '../../assets/qrcodeicon.png'

export function PixAndTransfers() {
  const navigate = useNavigate()

  return (
    <section className="flex items-start justify-start gap-7 flex-col px-7 py-11">
      <div className="space-y-7">
        <div className="space-y-7 text-center">
          <h4 className="text-3xl font-bold">Ações</h4>

          <div className="flex items-center justify-start flex-wrap gap-7">
            {/* <NewPix /> */}
            <button type="button" onClick={() => navigate('/pix')}>
              <LinkOption title="PIX" icon={newPixIcon} />
            </button>
            <button type="button" onClick={() => navigate('/pix/new-qrcode')}>
              <LinkOption title="QR Code" icon={qrcodeicon} />
            </button>
            <button
              type="button"
              onClick={() => navigate('/pix/copy-and-paste')}
            >
              <LinkOption title="Copia e Cola" icon={copypaste} />
            </button>
            <button type="button" onClick={() => navigate('/paybills/invoice')}>
              <LinkOption title="Pagar conta" icon={bill} />
            </button>
            {/* <button type="button" onClick={() => navigate("/transfer-wallet/wallet-list")}>
              <LinkOption title="ENTRE CONTAS" icon={transferIcon} />
            </button> */}
          </div>
        </div>
      </div>
    </section>
  )
}
